export class DataCatalogPipelineOutput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogName",
            "baseName": "catalogName",
            "type": "string",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "dataset",
            "baseName": "dataset",
            "type": "string",
            "format": ""
        },
        {
            "name": "sql",
            "baseName": "sql",
            "type": "string",
            "format": ""
        },
        {
            "name": "writeMode",
            "baseName": "writeMode",
            "type": "DataCatalogPipelineWriteMode",
            "format": ""
        },
        {
            "name": "runMode",
            "baseName": "runMode",
            "type": "DataCatalogPipelineRunMode",
            "format": ""
        },
        {
            "name": "primaryKey",
            "baseName": "primaryKey",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "partitionSpec",
            "baseName": "partitionSpec",
            "type": "Array<DataCatalogPipelineOutputPartitionSpecInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogPipelineOutput.attributeTypeMap;
    }
    constructor() {
    }
}
